// Productions Mutations

export const updateProductionsList = (state, payload) => {
  state.productionsList = payload
}

export const fetchProductionInfo = (state, payload) => {
  state.productionInfo = payload
}

export const fetchUnClosedProductionsCount = (state, payload) => {
  state.unclosedProductionsCount = payload
}
